import { Link } from 'gatsby';
import React from 'react';
import {
  byPublishedAtDesc,
  formatPublishedAt,
  isReleased,
  limitExcerpt,
} from '../utils/blog';

const LATEST_COUNT = 3;

const LatestBlogPosts = ({ posts = [] }) => {
  const latest = byPublishedAtDesc(posts.filter(isReleased)).slice(
    0,
    LATEST_COUNT
  );
  if (latest.length === 0) return null;

  return (
    <section className="latest-blog" id="from-the-blog">
      <div className="container">
        <div className="section-heading text-center">
          <h2>From the blog</h2>
          <p className="text-muted">
            News, product updates, and stories from ErgZone.
          </p>
          <hr />
        </div>

        <div className="row justify-content-center">
          {latest.map((post) => (
            <div
              key={post.id}
              className={
                latest.length === 1 ? 'col-lg-6 mb-4' : 'col-lg-4 col-md-6 mb-4'
              }
            >
              <article className="latest-blog-card">
                {post.imageUrl ? (
                  <Link
                    to={`/blog/${post.slug}`}
                    className="latest-blog-card-image"
                  >
                    <img src={post.imageUrl} alt="" />
                  </Link>
                ) : (
                  <div className="latest-blog-card-image" aria-hidden="true" />
                )}
                <div className="latest-blog-card-body">
                  <h3>
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  </h3>
                  {post.publishedAt && (
                    <p className="latest-blog-date">
                      {formatPublishedAt(post.publishedAt)}
                    </p>
                  )}
                  {post.excerpt && (
                    <p className="latest-blog-excerpt">
                      {limitExcerpt(post.excerpt)}
                    </p>
                  )}
                  <Link
                    to={`/blog/${post.slug}`}
                    className="latest-blog-read-more"
                  >
                    Read more
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </div>

        <div className="text-center mt-2">
          <Link to="/blog" className="latest-blog-all">
            View all posts
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LatestBlogPosts;
